module.exports = __webpack_public_path__ + "static/vegan-cola_logo_new-7e456dd80f288b5889513c43102caf0b.svg";